var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-content bg-purple chartCon"},[(_vm.chart.showTitle)?_c('div',{staticClass:"chartTitle blueTitle"},[_vm._v("数据走势")]):_vm._e(),_c('div',{staticClass:"chart chartBox",attrs:{"id":_vm.chart.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }